import IconChevronDown from '@apollo/icons/default/IconChevronDown.svg';
import {
  Button,
  Menu,
  MenuButton,
  MenuContent,
  MenuDivider,
  MenuItem,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
} from '@apollo/orbit';
import React from 'react';

import { useLocalStorage } from 'src/hooks/useLocalStorage';
import { useTrackCustomEvent } from 'src/hooks/useTrackCustomEvent';
import { useLDFlag } from 'src/lib/launchDarkly';

import { ErrorsView } from './sharedTypes';

export function ErrorsViewSelect({
  currentView,
  onViewChange,
}: {
  currentView: ErrorsView;
  onViewChange: (view: ErrorsView) => void;
}) {
  const migratedToNewErrorsView = useLDFlag('insights-error-categorization-ui');
  const [_, setMigrationView] = useLocalStorage('errorInsightsMigrationView');
  const trackCustomEvent = useTrackCustomEvent();

  const handleMenuOpen = () => {
    trackCustomEvent({
      category: 'Operation Insights Errors',
      action: 'errors_view_dropdown_open',
    });
  };
  const handleMenuClose = () => {
    trackCustomEvent({
      category: 'Operation Insights Errors',
      action: 'errors_view_dropdown_close',
    });
  };

  const handleViewChange = (view: ErrorsView) => {
    trackCustomEvent({
      category: 'Operation Insights Errors',
      action: 'errors_view_change',
      label: view,
    });
    onViewChange(view);
  };

  const handleLegacyClick = () => {
    setMigrationView('legacy');
    trackCustomEvent({
      category: 'Operation Insights Errors',
      action: 'errors_view_change',
      label: 'legacy',
    });
  };

  return (
    <Menu onOpen={handleMenuOpen} onClose={handleMenuClose}>
      <MenuButton
        as={Button}
        size="md"
        variant="secondary"
        className="flex-shrink-0"
        rightIcon={<IconChevronDown />}
      >
        {currentView === 'requests' ? 'Errored requests' : 'GraphQL errors'}
      </MenuButton>
      <MenuContent>
        <MenuList>
          <MenuOptionGroup
            label="View errors"
            type="radio"
            value={currentView}
            onChange={handleViewChange}
          >
            <MenuItemOption value="graphql" type="radio">
              GraphQL errors
            </MenuItemOption>
            <MenuItemOption value="requests" type="radio">
              Errored requests
            </MenuItemOption>
          </MenuOptionGroup>
          {!migratedToNewErrorsView && (
            <>
              <MenuDivider />
              <MenuItem onClick={handleLegacyClick}>
                Switch to legacy view
              </MenuItem>
            </>
          )}
        </MenuList>
      </MenuContent>
    </Menu>
  );
}
